import { graphConfig } from './authConfig';
import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { AccountInfo, InteractionRequiredAuthError } from '@azure/msal-browser';
import { ExtendedAccountInfo } from './types/types';

export const useGroupMembershipCheck = (groupIds: string[]) => {
    const { instance, accounts } = useMsal();
    const [isMemberInGroups, setIsMemberInGroups] = useState<{
        [key: string]: boolean;
    }>({});
    const [loading, setLoading] = useState(true);
    //const [user, setUser] = useState<AccountInfo>({} as AccountInfo);
    const [user, setUser] = useState<ExtendedAccountInfo>(
        {} as ExtendedAccountInfo
    );

    const account = accounts[0];
    const accountId = account?.homeAccountId;

    useEffect(() => {
        const checkGroupMembership = async () => {
            if (accounts.length === 0) {
                setLoading(false);
                return;
            }

            if (!accountId) {
                setLoading(false);
                return;
            }
            setLoading(true);

            const initialState = groupIds.reduce(
                (state, groupId) => {
                    state[groupId] = false;
                    return state;
                },
                {} as { [key: string]: boolean }
            );

            //setIsMemberInGroups(initialState);

            try {
                const accessTokenResponse = await instance.acquireTokenSilent({
                    scopes: ['User.Read'],
                    account: accounts[0],
                });

                if (accounts[0]) {
                    setUser(accounts[0]);
                }

                let url =
                    'https://graph.microsoft.com/v1.0/me/checkMemberGroups';
                const headers = {
                    Authorization: `Bearer ${accessTokenResponse.accessToken}`,'Content-Type': 'application/json'
                };
                const body = JSON.stringify({
                    groupIds: groupIds
                });
                
                const checkMembership = async (url: string) => {
                    const response = await fetch(url, {  method: 'POST',
                        headers: headers,
                        body: body });
                    const data = await response.json();
                
                    if (response.ok) {
                        const memberships = data.value;
                        let foundGroupIds = new Set();
                
                        // Update the state for each group based on the received memberships
                        memberships.forEach((membershipId: string) => {
                            if (groupIds.includes(membershipId)) {
                                setIsMemberInGroups((prevState) => ({
                                    ...prevState,
                                    [membershipId]: true,
                                }));
                                foundGroupIds.add(membershipId);
                            }
                        });
                        // groupIds.forEach((groupId) => {
                        //     if (memberships.some((id: any) => id === groupId)) {
                        //         setIsMemberInGroups((prevState) => ({
                        //             ...prevState,
                        //             [groupId]: true,
                        //         }));
                        //         foundGroupIds.add(groupId);
                        //     }
                        // });
                
                        // // Check if all required groups have been found
                        // if (foundGroupIds.size < groupIds.length && data['@odata.nextLink']) {
                        //     // If not all groups have been found and there is a next page, continue checking
                        //     await checkMembership(data['@odata.nextLink']);
                        // }
                    } else {
                        throw new Error('Failed to fetch group membership from Microsoft Graph API');
                    }
                };

                await checkMembership(url);
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    // fallback to interaction when silent call fails
                    instance.acquireTokenRedirect({
                        scopes: ['User.Read'],
                        account: accounts[0],
                    });
                } else {
                    console.error(error);
                }
            } finally {
                setLoading(false);
            }
        };

        checkGroupMembership();
    }, [instance, accountId]);
    //}, [groupIds, instance, accounts]);

    return { isMemberInGroups, loading, user };
};
